import React from "react";
//Functional Component 
const Page404 = () => {
  return (
    <div>
      <h1 style={{color:'black',display:'float',textAlign:'center'}}>Error 404: The Page was not found :(</h1>
    </div>
  );
};

export default Page404;